import React from "react";
import "./styles.css";

function Anchor({ link, icon, text, background, color }) {
  return (
    <a
      className="anchor"
      target="_blank"
      rel="noreferrer"
      href={link}
      style={{
        color: color,
        backgroundColor: background,
      }}
    >
      <span>
        {icon}
        {text}
      </span>
    </a>
  );
}

export default Anchor;
